import type { ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Button } from "@krea/shared/design-system/Button";
import { Text } from "@krea/shared/design-system/Text";
import type { CountryCode } from "@krea/shared/types/common";

import { SimpleCheckmark } from "./SimpleCheckmark";

export const StartApplicationSection = ({
  handleSubmit,
  renderReviewBadges,
  countryCode,
  showUsps,
  showButton = true,
}: {
  handleSubmit: () => void;
  renderReviewBadges?: (countryCode: CountryCode) => ReactNode;
  countryCode: CountryCode;
  showUsps: boolean;
  showButton?: boolean;
}) => {
  const { t } = useTranslation("loanWidget");

  return (
    <div>
      {showButton && (
        <Button
          size="lg"
          className="w-full bg-primary hover:bg-primary/90 mb-4"
          onClick={handleSubmit}
        >
          {t("loanWidget.continueToApplication")}
        </Button>
      )}
      {renderReviewBadges && (
        <div className="flex flex-row flex-wrap justify-between items-center mb-4">
          {renderReviewBadges(countryCode)}
        </div>
      )}
      {showUsps && (
        <div className="mb-4">
          <Text className="font-semibold mb-3">
            {t("loanWidget.continueNowToGetRealOffers")}
          </Text>
          <div className="space-y-2">
            <SimpleCheckmark>
              <Trans
                ns="loanWidget"
                i18nKey="loanWidget.howItWorksDescription1"
              />
            </SimpleCheckmark>
            <SimpleCheckmark>
              <Trans
                ns="loanWidget"
                i18nKey="loanWidget.howItWorksDescription2"
              />
            </SimpleCheckmark>
            <SimpleCheckmark>
              <Trans
                ns="loanWidget"
                i18nKey="loanWidget.howItWorksDescription3"
              />
            </SimpleCheckmark>
          </div>
        </div>
      )}
    </div>
  );
};
